import { render, staticRenderFns } from "./BrandOtherEdit.vue?vue&type=template&id=58873eae&"
import script from "./BrandOtherEdit.vue?vue&type=script&lang=js&"
export * from "./BrandOtherEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrandOtherEdit.vue?vue&type=style&index=0&id=58873eae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports